export default function Users()  {
  return(
    <div>Brugere</div>
  );
}